import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { LocalScheme } from '~auth/runtime'
import { Oauth2Scheme } from '~auth/runtime'
import { default as Scheme$2090 } from '/opt/buildhome/repo/schemes/appleId.js'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": false,
  "redirect": {
    "login": "/login",
    "logout": "/",
    "home": "/feed",
    "callback": "/login"
  },
  "vuex": {
    "namespace": "auth"
  },
  "cookie": {
    "prefix": "auth.",
    "options": {
      "path": "/"
    }
  },
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "local",
  "tokenRequired": true,
  "tokenName": "Authorization",
  "tokenType": "Token",
  "tokenMaxAge": 604800
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // local
  $auth.registerStrategy('local', new LocalScheme($auth, {
  "user": {
    "property": "",
    "autoFetch": true
  },
  "endpoints": {
    "login": {
      "url": "https://api.followingpilots.com/api/user/login/",
      "method": "post"
    },
    "user": {
      "url": "https://api.followingpilots.com/api/user/profile/",
      "method": "get"
    },
    "logout": {
      "url": "https://api.followingpilots.com/api/user/logout/",
      "method": "post"
    }
  },
  "token": {
    "name": "Authorization",
    "type": "Token",
    "maxAge": 604800
  },
  "name": "local"
}))

  // facebook
  $auth.registerStrategy('facebook', new Oauth2Scheme($auth, {
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 604800
  },
  "endpoints": {
    "authorization": "https://facebook.com/v2.12/dialog/oauth",
    "userInfo": "https://graph.facebook.com/v6.0/me?fields=id,name,picture{url}"
  },
  "clientId": "307828958147204",
  "scope": [
    "public_profile",
    "email",
    "public_profile",
    "email"
  ],
  "name": "facebook"
}))

  // google
  $auth.registerStrategy('google', new Oauth2Scheme($auth, {
  "clientId": "337501026759-gephv1ktdh8it3vbqkam0frsnmum2tii.apps.googleusercontent.com",
  "codeChallengeMethod": "",
  "responseType": "token id_token",
  "endpoints": {
    "authorization": "https://accounts.google.com/o/oauth2/auth",
    "userInfo": "",
    "token": ""
  },
  "name": "google",
  "scope": [
    "openid",
    "profile",
    "email"
  ]
}))

  // googleAndroid
  $auth.registerStrategy('googleAndroid', new LocalScheme($auth, {
  "endpoints": {
    "login": {
      "url": "https://api.followingpilots.com/api/user/social-login/google-ios/",
      "method": "post"
    },
    "user": {
      "url": "https://api.followingpilots.com/api/user/profile/",
      "method": "get"
    },
    "logout": {
      "url": "https://api.followingpilots.com/api/user/logout/",
      "method": "post"
    }
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 604800
  },
  "name": "googleAndroid"
}))

  // facebookAndroid
  $auth.registerStrategy('facebookAndroid', new LocalScheme($auth, {
  "endpoints": {
    "login": {
      "url": "https://api.followingpilots.com/api/user/social-login/facebook/",
      "method": "post"
    },
    "user": {
      "url": "https://api.followingpilots.com/api/user/profile/",
      "method": "get"
    },
    "logout": {
      "url": "https://api.followingpilots.com/api/user/logout/",
      "method": "post"
    }
  },
  "token": {
    "property": "access_token",
    "type": "Bearer",
    "maxAge": 604800
  },
  "name": "facebookAndroid"
}))

  // apple-id
  $auth.registerStrategy('apple-id', new Scheme$2090($auth, {
  "name": "apple-id"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
